import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'templateController';
export default {
    /**
     * 模板按条件分页查询
     */
    getTemplatesByCondition: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplatesByCondition',
        type: requestType.Get
    },
    /**
     * 新增模板信息
     */
    createTemplate: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'createTemplate',
        type: requestType.Post
    },
    /**
     * 根据模板ID删除模板
     */
    deleteTemplateById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'deleteTemplateById',
        type: requestType.Delete
    },
    /**
     * 根据模板ID查询模板
     */
    getTemplateById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplateById',
        type: requestType.Get
    },
    /**
     * 根据模板类别获取模板列表
     */
    getTemplateByCatogory: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplateByCatogory',
        type: requestType.Get
    },
    /**
     * 查询模板形式
     */
    getTemplateStyle: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplateStyle',
        type: requestType.Get
    },
    /**
     * 查询模板类别
     */
    getTemplateType: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplateType',
        type: requestType.Get
    },
    /**
     * 根据模板形式、类别、名称查询启用的模板
     */
    getTemplatesByStyleAndType: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplatesByStyleAndType',
        type: requestType.Get
    },
    /**
     * 根据模板形式查询启用的模板
     */
    getTemplatesByStyle: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplatesByStyle',
        type: requestType.Get
    },
    /**
     * 更新模板信息
     */
    updateTemplate: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'updateTemplate',
        type: requestType.Put
    },
    /**
     * 根据逾期阶段查询模板
     */
    getTemplateByOverduePeriod: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplateByOverduePeriod',
        type: requestType.Get
    },
    /**
     * 根据适用部门搜索合同模板
     */
    getTemplateByDistributeType: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplateByDistributeType',
        type: requestType.Get
    },
    /**
     * 生成合同
     */
    createContractInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'createContractInfo',
        type: requestType.Post
    },
    /**
     * 查询案件合同列表
     */
    getContractInfoByCaseId: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getContractInfoByCaseId',
        type: requestType.Get
    },
};
